export default "<p>kunden-zuweisung works!</p>\r\n";